import fb from '../../firebase';

export const GetCollectionDocs = async (data) => {
    const collection = await fb.doGetCollection(data);
    return collection.docs.map(doc => doc.data());
}


